import { TreatmentType } from '../interfaces/treatment';

export class MTreatmentType{
    public id: number = null;
    public name: string = null;

    constructor(type: TreatmentType){
        this.id = type.id;
        this.name = type.nombre;
    }
}